import { z } from "zod/v4";

export const membershipKindSchema = z.enum(["active", "passive", "youth", "honorary", "trial"]);

export type MembershipKind = z.infer<typeof membershipKindSchema>;

export const membershipTypeSchema = z.object({
	id: z.string().uuid(),
	club_id: z.string().uuid(),
	name: z.string(),
	kind: membershipKindSchema,
	fee_id: z.string().uuid().nullable().optional(),
	trial_days: z.number().int().nullable().optional(),
	position: z.number().int(),
	is_active: z.boolean(),
	created_at: z.coerce.date(),
	updated_at: z.coerce.date(),
});

export type MembershipType = z.infer<typeof membershipTypeSchema>;

export const createMembershipTypeSchema = z.object({
	name: z.string().min(1, "Name is required"),
	kind: membershipKindSchema,
	fee_id: z.string().uuid().optional(),
	trial_days: z.number().int().positive().optional(),
	position: z.number().int().optional(),
	is_active: z.boolean().optional(),
});

export type CreateMembershipType = z.infer<typeof createMembershipTypeSchema>;

export const updateMembershipTypeSchema = z.object({
	name: z.string().min(1).optional(),
	kind: membershipKindSchema.optional(),
	fee_id: z.string().uuid().optional(),
	trial_days: z.number().int().positive().optional(),
	position: z.number().int().optional(),
	is_active: z.boolean().optional(),
	clear_fee: z.boolean().optional(),
	clear_trial: z.boolean().optional(),
});

export type UpdateMembershipType = z.infer<typeof updateMembershipTypeSchema>;
